"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPercentageDiff = void 0;
const to_num_1 = require("./to-num");
const getPercentageDiff = (premiumAndDelta, premiumAndDeltaPromo) => {
    const premiumAndDeltaNum = (0, to_num_1.toNum)(premiumAndDelta) || 0;
    const premiumAndDeltaPromoNum = (0, to_num_1.toNum)(premiumAndDeltaPromo) || 0;
    if (!premiumAndDeltaNum) {
        return 0;
    }
    return Math.round((premiumAndDeltaNum - premiumAndDeltaPromoNum) / (premiumAndDeltaNum / 100));
};
exports.getPercentageDiff = getPercentageDiff;
